



































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import { AuthState, AuthActionTypes, namespaceAuth } from "../store/auth";
import { EmailCredentials, RegistrationPayload } from "../models/auth.model";
import { Route } from "vue-router";
import { ButtonPlugin } from "bootstrap-vue";

Vue.use(ButtonPlugin);

@Component({
  name: "AuthPage",
  computed: {
    ...mapGetters(namespaceAuth, {
      isLoggedIn: "isLoggedIn",
      getEmail: "getEmail"
    })
  }
})
export default class AuthPage extends Vue {
  @Watch("isLoggedIn", { immediate: true })
  onLoginChanged(isLoggedIn: boolean) {
    if (isLoggedIn) {
      const redirect = this.$route.query["redirect"] as string;
      const path = redirect || "/";
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    }
  }
}
